import React, { useState } from 'react';
// import SummaryCards from './summaryCards';
// import RevenueChart from './revenueChart';
import RecentActivities from './recentActivities';
// import TicketSales from './ticketSales';
// import EventList from './eventList';
import EngagementCalendar from '../../../shared/engagementCalendar';
import styles from './dashboard.module.scss';
import { KoCharts,KoSkeleton, KoText, KoTitle } from 'packages';
import KoIcon from '@kwapio/icons';
import RoundedBarLineChartConfig from './revenue';
import LollipopLabelChart from './lollipopLabelChart';
import EventsByTypeChart from './eventsByTypeChart';
import SlotsBookedTrendChart from './slotsBookedTrendChart';
import TicketStepLineChart from './ticketStepLineChart';
export default function Dashboard() {
  const [dashboardCards] = useState([
    {
      label: 'Total Event',
      icon: 'TaskClockCompltionFilled',
      arrow: 'ArrowLineUpFilled',
      description: '8% last month',
      value: `213`
    },
    {
      label: 'Ticket Sold',
      icon: 'RevenueFilled',
      value: `123`,
      description: 'Total created project tasks',
      arrow: 'ArrowLineUpFilled'
    },
    {
      label: 'Upcoming Event',
      icon: 'ClockFilled',
      value: `10`,
      description: 'Overall task completion rate',
      arrow: 'ArrowLineUpFilled',
      progress: 30
    }]);

  const [loadingCards] = useState(false);
  return (
    <div className={styles.wrapper}>
      <KoTitle text="Dashboard" level={3} className={styles.title} />
      <div className={styles.contentRowOne}>
        <div className={styles.contentBoxWrapper}>
          <div className={styles.contentBox}>
            {
              !loadingCards && dashboardCards.length > 0 && dashboardCards.map((i) => <div key={i} className={styles.card}>
                <div className={styles.icon}>
                  <KoIcon name={i.icon} width={46} height={46} />
                </div>
                <div className={styles.mycontent}>
                  <KoText className={styles.label} text={i.label} />
                  <KoTitle level={1} className={styles.value} text={i.value} />
                  <div className={styles.descriptionBox}>
                    <KoIcon name={i.arrow} width={16} height={16} />
                    <KoText className={styles.description} text={i.description} />
                  </div>
                </div>
              </div>)
            }
            {
              loadingCards && [1, 2, 3].map((i) => <KoSkeleton active={true} key={i} type={'card'} />)
            }
          </div>
          <div className={styles.graphWrapper}>
            <KoTitle text={`Revenue Breakdown`} level={4} />
            <div className={styles.graph}>
              <KoCharts option={RoundedBarLineChartConfig()} />
            </div>
            <div className={styles.footer}>
              <div className={styles.footerItem}>
                <div className={styles.circleWrapper}>
                  <div className={styles.circleList}>
                    <div className={styles.circle}/>
                    <KoTitle text={`Total Revenue Summary`} level={5} />
                  </div>
                  <KoTitle text={`$100,000`} level={1} />
                </div>
              </div>
              <div className={styles.footerItem}>
                <div className={styles.circleWrapper}>
                  <div className={styles.circleList}>
                    <div className={styles.circle}/>
                    <KoTitle text={`Month over Month Change`} level={5} />
                  </div>
                  <KoTitle text={`$100,000`} level={1} />
                </div>
              </div>
            </div>
          </div>
          <div className={styles.breakdown}>
            <div className={styles.events}>
              <div className={styles.event}>
                <KoTitle text={`Event`} level={4} />
                { [1,2,4].map((i) =>
                  <div key={i} className={styles.eventBox}>
                    <div className={styles.eventData}>
                      <div className={styles.eventIcon}>
                        <KoIcon name={'CalendarFilled'} width={40} height={40} />
                      </div>
                      <div className={styles.eventName}>
                        <KoText className={styles.eventTitle} ellipsis={true} text={`Future of AI`} />
                        <div className={styles.eventTime}>
                          <div className={styles.eventTimeItem}>
                            <KoIcon name={'CalendarOutlined'} width={14} height={14} />
                            <KoText className={styles.eventDate} text={`Today`} />
                          </div>
                          <div className={styles.eventTimeItem}>
                            <KoIcon name={'LogOutlined'} width={12} height={12} />
                            <KoText className={styles.eventDate} text={`Today`} />
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className={styles.eventFooter}>
                      <KoText text={`$100,000`} />
                      <KoText text={`$100,000`} />
                    </div>
                  </div>
                )}
              </div>
              <div className={styles.location}>
                <KoIcon name={'MapFilled'} width={350} height={340} />
                <div className={styles.locationText}>
                  <div className={styles.locationItem}>
                    <KoTitle ellipsis={true} text={`Location`} level={5} />
                    <div className={styles.locationBox}>
                      <KoIcon name={'LocationFilled'} width={20} height={20} />
                      <KoText text={`New York, USA`} />
                    </div>
                  </div>
                  <KoIcon name={'MapOutlined'} color={'var(--palette-gray-7)'} width={30} height={30} />
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={styles.contentRecentWrapper}>
          <div className={styles.contentRecent}>
            <KoTitle text={`Recent Activities`} level={4} />
            <div className={styles.lollipopLabelChart}>
              <KoCharts option={LollipopLabelChart()} />
            </div>
            <div className={styles.recentActivities}>
              <RecentActivities />
            </div>
          </div>
          <div className={styles.contentEngagement}>
            <KoTitle text={`Event Engagement`} level={4} />
            <EngagementCalendar />
          </div>
        </div>
        <div className={styles.contentsummary}>
          <KoTitle text={`Ticket summary`} level={4} />
          <div className={styles.ticketSales}>
            <div className={styles.ticketSalesCard}>
              <KoTitle text={`Slots Booked Over Time`} level={4} />
              <KoCharts option={SlotsBookedTrendChart()} />
            </div>
            <div className={styles.ticketSalesCard}>
              <KoTitle text={`Total Events by Type`} level={4} />
              <KoCharts option={EventsByTypeChart()} />
            </div>
            <div className={styles.ticketSalesCard}>
              <KoTitle text={`Ticket Conversion`} level={4} />
              <KoCharts option={TicketStepLineChart()} />
            </div>
          </div>
        </div>
      </div>

      {/* 
      <SummaryCards />

      <Row gutter={16} className={styles.section}>
        <Col span={16}><RevenueChart /></Col>
        <Col span={8}><RecentActivities /></Col>
      </Row>

      <Row gutter={16} className={styles.section}>
        <Col span={8}><EventList /></Col>
        <Col span={8}><EngagementCalendar /></Col>
        <Col span={8}><TicketSales /></Col>
      </Row> */}
    </div>
  );
}

